export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_REGISTER = "AUTH_REGISTER";
export const HANDLE_LOADING = "HANDLE_LOADING";
export const HANDLE_ERROR = "HANDLE_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
